import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function AppShell({ children }: { children: ReactNode }) {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="site-frame">
      <header className="site-header">
        <Link className="brand" to="/" aria-label="返回自助排查首页">
          <span className="brand-mark" aria-hidden="true">
            ✓
          </span>
          <span>
            <strong>兑换自助排查</strong>
            <small>不需要账号密码</small>
          </span>
        </Link>
        {!isHome && (
          <Link className="quiet-link" to="/">
            重新开始
          </Link>
        )}
      </header>
      <main id="main-content">{children}</main>
      <footer className="site-footer">
        <span>只做问题排查，不收集账号信息</span>
        <nav aria-label="页脚导航">
          <Link to="/activate">激活帮助</Link>
          <Link to="/guide">完整教程</Link>
          <Link to="/privacy">隐私说明</Link>
        </nav>
      </footer>
    </div>
  );
}
